window.addEventListener('orientationchange', function (event) {
  Turbo.visit(window.location.toString(), { action: 'replace' })
  console.log('screen orientation changed')
})